import styled from 'styled-components'

import { helpers } from 'styles'

export const SeparatorNamed = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin: 24px 0;
	color: ${helpers.color.textMuted};
	font-size: ${helpers.font.size.smaller};
	line-height: 1;

	&:before,
	&:after {
		content: '';
		flex: 1;
		height: 1px;
		background-color: ${helpers.color.separator};
	}
`
